import {
  createRequestContract,
  createResponseContract,

  requestVerbs,
  responseTypes,
  FetchPolicy,
} from '@bingads-webui-react/overreact';

import { edm } from '../../../environment/edm';
import { schema } from '../../../environment/schema';
import { getBulkUrl, getBulkPayload, getProcessedBulkResult, getDefaultHeaderObj } from '../../../request-contract-helper';

function odataUrlFactory(params) {
  return getBulkUrl(params);
}

function odataHeaderFactory() {
  return getDefaultHeaderObj();
}

function odataPayloadFactory(params) {
  const { data } = params;
  return getBulkPayload(edm.schema.schemas['Model/Campaign'], data);
}

function processor(response, request) {
  return getProcessedBulkResult(response, request);
}

function entityProcessor(response, request) {
  return getProcessedBulkResult(response, request)[0];
}

export const mutationRequestContract = createRequestContract({
  schema,
  dataPath: 'customer:account:campaign',
  verb: requestVerbs.POST,
  fetchPolicy: FetchPolicy.NetworkOrStore,
  uriFactoryFn: odataUrlFactory,
  headerFactoryFn: odataHeaderFactory,
  payloadFactoryFn: odataPayloadFactory,
  keySelector: campaign => campaign.Id,
  parentKeySelector: variables => variables.locator.descriptor.aid,
});

export const mutationResponseContract = createResponseContract({
  requestContract: mutationRequestContract,
  responseType: responseTypes.COLL,
  keySelector: campaign => campaign.Id,
  processorFn: processor,
});

export const mutationEntityResponseContract = createResponseContract({
  requestContract: mutationRequestContract,
  responseType: responseTypes.ENTITY,
  keySelector: campaign => campaign.Id,
  processorFn: entityProcessor,
});
